// #region titleUpdate
export function titleUpdate(title: string | undefined): void {
  if (title) {
    document.title = title + " | KD Strategies";
  } else {
    document.title = "KD Strategies";
  }
}
// #endregion titleUpdate
